// Referenzen.js – Seite /referenzen: Karte (ReferenzKarte) und je Projekt ein Artikel mit Vorher/Nachher-Regler oder Fotoreihe.
// Inhalte kommen aus src/data/referenzen.js und orte.js; hier ist nichts von Hand zu pflegen.
import "./Home.css";
import "./custom.css";
import usePageMeta from "../../usePageMeta";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import BeforeAfter from "./BeforeAfter";
import ReferenzKarte from "./ReferenzKarte";
import referenzen from "../../data/referenzen";
import { standorte } from "../../data/orte";

const projekte = standorte(referenzen);

function Referenzen() {
  usePageMeta({
    path: "/referenzen",
    title: "Referenzen: Projekte aus Schleswig-Holstein | Forst & Flur",
    description:
      "Ausgewählte Projekte von Forst & Flur: Baumfällung, Baumpflege und Landschaftspflege in Schleswig-Holstein, mit Karte und Vorher-Nachher-Vergleich.",
  });

  return (
    <div>
      <div className="ff-page-hero">
        <div className="ff-page-hero__content">
          <span className="ff-eyebrow">Forst &amp; Flur</span>
          <h1 className="ff-page-hero__title">Referenzen</h1>
          <p className="ff-page-hero__sub">Ausgewählte Projekte aus Schleswig-Holstein</p>
        </div>
      </div>

      <div className="custom-dark-green text-white">
        <Container className="py-5">
          <Row className="justify-content-center">
            <Col xs={12} lg={10}>
              <ReferenzKarte referenzen={projekte} />
            </Col>
          </Row>

          <Row className="justify-content-center gy-5 mt-2">
            {projekte.map((r, i) => (
              <Col xs={12} lg={10} key={r.id}>
                <article id={`ref-${r.id}`} className={`ff-ba-panel ${r.bilder ? "ff-ba-panel--gallery" : ""}`}>
                  {r.vergleich && (
                    <div className="ff-ba-panel__media">
                      <BeforeAfter
                        before={r.vergleich.vorher}
                        after={r.vergleich.nachher}
                        width={r.vergleich.breite}
                        height={r.vergleich.hoehe}
                        beforeAlt={r.vergleich.vorherAlt}
                        afterAlt={r.vergleich.nachherAlt}
                        ratio={r.vergleich.ratio}
                        caption="Regler ziehen oder auf „Vorher“ und „Nachher“ tippen"
                      />
                    </div>
                  )}
                  <div className="ff-ba-panel__body" style={r.vergleich ? undefined : { gridColumn: "1 / -1" }}>
                    <span className="ff-eyebrow">
                      <span className="ff-ref-nr">{i + 1}</span>
                      {r.leistung}
                      {r.ort ? ` · ${r.ort}` : ""}
                      {r.jahr ? ` · ${r.jahr}` : ""}
                    </span>
                    <h2 className="ff-article-h3">{r.titel}</h2>
                    {[].concat(r.text).map((t) => (
                      <p key={t.slice(0, 24)} className="ff-ba-panel__lead">{t}</p>
                    ))}
                  </div>
                  {r.bilder && (
                    <div className="ff-ref-gallery">
                      {r.bilder.map((b) => (
                        <figure key={b.src} className="ff-ref-gallery__item">
                          <img src={b.src} width={b.breite} height={b.hoehe} alt={b.alt} loading="lazy" decoding="async" />
                          {b.label && <span className="ff-ba__tag ff-ref-gallery__tag">{b.label}</span>}
                        </figure>
                      ))}
                    </div>
                  )}
                </article>
              </Col>
            ))}
          </Row>

          <Row className="justify-content-center mt-4">
            <Col xs={12} lg={10} className="text-center">
              <p className="fs-5 text-shadow">
                Sie haben ein ähnliches Vorhaben? Ich schaue mir Ihr Grundstück gern vor Ort an.
              </p>
              <Link to="/kontakt" className="btn-ff-primary" onClick={() => window.scrollTo(0, 0)}>
                Jetzt anfragen
              </Link>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default Referenzen;
